import React from 'react';
import Icon from 'react-icons-kit';
import { download } from 'react-icons-kit/fa';

import _ from '@ihme/common/locale';
import styled from '@ihme/common/theme/styled';
import { Button, Col, Row } from '@ihme/common/web/components';

import { sortLocationOptions } from '../../utility/sort-helpers';

import ChartDropdown from '../../components/ChartDropdown';

import Risks from './Risks';
import YLL from './YLL';
import Deaths from './Deaths';

const PageHeader = styled.header(({ theme }) => ({
    marginLeft: 15,
    marginTop: 48,
    marginBottom: 50,
}));

const Title = styled.h1(({ theme }) => ({
    marginRight: 19,
    display: 'inline',
    fontSize: theme.typography.fontSize.h1,
    fontWeight: theme.typography.fontWeight.base,
    textAlign: 'center',
    textTransform: 'uppercase',
    color: theme.textColor.surface,
    paddingBottom: 16,
    letterSpacing: -0.18,
}));

const LocationDropdown = styled(ChartDropdown)(({theme}) => ({
    display: 'inline-block',
    width: 185,
    marginBottom: -3,
    verticalAlign: 'text-bottom',
}));

const Subtitle = styled.p(({ theme }) => ({
    marginTop: 6,
    marginBottom: 75,
    [theme.breakpoint.xs]: {
        marginBottom: 20,
    },
}));

const Section = styled.section(({ theme }) => ({
    marginBottom: 80,
    [theme.breakpoint.xs]: {
        marginBottom: 28,
    },
}));

const SnapshotHelper = styled.div(() => ({
    height: 1,
    width: '100%',
    backgroundColor: 'transparent',
}));

const ExportButton = styled(Button)(() => ({
    float: 'right',
}));

type Props = {
    locationId: number;
    locations: number[];
    onLocationChange: (id: number) => void;
    onScreenshot: (view) => void;
};

class View extends React.PureComponent<Props> {
    viewRef = React.createRef();

    render() {
        const { locationId, locations, onLocationChange, onScreenshot } = this.props;

        return (
            <div ref={this.viewRef}>
                <PageHeader>
                    <Row>
                        <Col xs={10} md={11}>
                            <Title>{_('factsheets_scene_title')}</Title>
                            <LocationDropdown
                                key={locations.join(',')}
                                filtersOptions={{ location_id: locations }}
                                filtersValues={{ location_id: locationId }}
                                setFiltersValues={{ location_id: () => null }}
                                localePrefix="location_"
                                filterKey="location_id"
                                isSearchable
                                showPrefix={false}
                                onChange={onLocationChange}
                                preprocessOptions={sortLocationOptions}
                            />
                            <Subtitle>{_('factsheets_scene_sub_title')}</Subtitle>
                        </Col>
                        <Col xs={2} md={1}>
                            <ExportButton onClick={() => onScreenshot(this.viewRef.current)}>
                                <Icon size={14} icon={download} />
                            </ExportButton>
                        </Col>
                    </Row>
                </PageHeader>

                <Section>
                    <Risks locationId={locationId} />
                </Section>
                <Section>
                    <YLL locationId={locationId} />
                </Section>
                <Section>
                    <Deaths locationId={locationId} />
                </Section>

                {/* required for snapshot correct bottom padding */}
                <SnapshotHelper />
            </div>
        );
    }
}

export default View;
